
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {
Cell,
Group,
Confirm
},
data() {
return {
account: "",
imgUrl: "/static/img/vip.png",
name: "",
mobile: "",
showContent004: false,
list: [],
isShow: false,
username: "",
pwd: "",
signoutShow: false
};
},
methods: {
signout() {
let openid = localStorage.getItem("openid");
const unionid = localStorage.getItem('unionid')
let that = this;
switch (this.list.length) {
case 3:
this.$http.post('/api/v1/wechat/' + unionid + '/token', {'account': this.list[2]}).then(res => {
let opid = res.data.userid
let obj = {
headers: {
token: res.data.token,
opid
}
};
this.$http.delete("/api/v1/wechat/" + unionid + "?userid=" + opid, obj).then(res => {
})
})
case 2:
this.$http.post('/api/v1/wechat/' + unionid + '/token', {'account': this.list[1]}).then(res => {
let opid = res.data.userid
let obj = {
headers: {
token: res.data.token,
opid
}
};
this.$http.delete("/api/v1/wechat/" + unionid + "?userid=" + opid, obj).then(res => {
})
})
case 1:
this.$http.post('/api/v1/wechat/' + unionid + '/token', {'account': this.list[0]}).then(res => {
let opid = res.data.userid
let obj = {
headers: {
token: res.data.token,
opid
}
};
this.$http.delete("/api/v1/wechat/" + unionid + "?userid=" + opid, obj).then(res => {
})
})
break;
}
setTimeout(() => {
localStorage.clear()
that.$router.push({name: "login"});
}, 500)

},
onShow() {
this.signoutShow = true;
},
onHide() {
this.signoutShow = false;
},
show() {
this.isShow = !this.isShow;
},
hide() {
this.isShow = !this.isShow;
},
add() {
let userInfo = {
passwd: this.pwd,
account: this.username,
is_passwd: true,
tp: 'mobile'
};
this.isShow = !this.isShow;
let roles = [];
JSON.parse(localStorage.getItem('account')).forEach(item => {
roles.push(item.role);
});
this.$http.post("/api/v1/accounts", userInfo)
.then(res => {
let head = {headers: {token: res.data.token, opid: res.data.userid}};
this.$http.get('/api/v1/accounts/' + res.data.userid, head)
.then((res1) => {
res1.data.forEach(item => {
console.log(roles)
if (roles.indexOf('ADMIN') !== -1) {
if (item.type !== 'ADMIN' && item.type !== 'INDV' && item.type !== 'EXPT' && item.type !== 'ENTP') {
console.log("bind")
this.bind(res.data.userid, head)
} else {
this.$vux.toast.show({
text: '不可绑定相同权限账号',
type: 'cancel',
time: '1000'
})
}
} else if (roles.indexOf('SRVP') !== -1) {
if (item.type !== 'SRVP' && item.type !== 'INDV' && item.type !== 'EXPT' && item.type !== 'ENTP') {
this.bind(res.data.userid, head)
} else {
this.$vux.toast.show({
text: '不可绑定相同权限账号',
type: 'cancel',
time: '1000'
})
}
} else if (item.type !== 'INDV' && item.type !== 'EXPT' && item.type !== 'ENTP') {
this.bind(res.data.userid, head)
}
});
})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
});
},
bind(userid, head) {
const openid = localStorage.getItem("openid");
const unionid = localStorage.getItem('unionid')
const nickname = localStorage.getItem('nickname')
const imgurl = localStorage.getItem('imgurl')
var obj = {
account: userid.toString(),
unionid:unionid,
nickname:nickname,
imgurl:imgurl,
otp:'official'
};
this.$http.post("/api/v1/wechat/" + openid, obj, head)
.then(() => {
this.$http.get("/api/v1/wechat/" + unionid).then(res => {
res.data.forEach(item => {
if (this.list.indexOf(item.account) === -1) {
this.list.push(item.account);
}
})
alert("绑定成功");
});
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
});
},
tobinding(id) {
this.$router.push({
name: "binding",
params: {id}
});
}
},
created() {
let openid = localStorage.getItem("openid");
const unionid = localStorage.getItem('unionid')
this.$http.get("/api/v1/wechat/" + unionid).then(res => {
res.data.forEach(item => {
if (this.list.indexOf(item.account) === -1) {
this.list.push(item.account);
}
})
});
},
beforeRouteEnter(to, from, next) {
if (from.name === "vip") {
next(vm => {
vm.name = vm.$route.params.obj.name;
vm.mobile = vm.$route.params.obj.mobile;
localStorage.setItem("name", vm.$route.params.obj.name);
localStorage.setItem("mobile", vm.$route.params.obj.mobile);
});
} else {
next(vm => {
vm.name = localStorage.getItem("name");
vm.mobile = localStorage.getItem("mobile");
});
}
},
beforeRouteLeave(to, from, next) {
if (to.name !== "binding") {
localStorage.removeItem("name");
localStorage.removeItem("mobile");
}
next();
}
};



// WEBPACK FOOTER //
// ./src/components/glzh.vue